import { Component } from '@angular/core';

import {
  BadgeComponent,
  BannerComponent,
  BulletComponent,
  LabelComponent,
  LinkComponent,
  NewComponent,
  TextComponent,
  TitleComponent,
  ToastComponent,
  TypedMessageComponent,
} from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        BadgeComponent,
        BannerComponent,
        BulletComponent,
        LabelComponent,
        LinkComponent,
        NewComponent,
        TestIdDirective,
        TextComponent,
        TitleComponent,
        ToastComponent,
        TypedMessageComponent,
    ],
    template: `
    <cam-text camTestId="cam-text">Some body text</cam-text>
    <cam-title camTestId="cam-title">A page title</cam-title>
    <cam-label camTestId="cam-label">A label</cam-label>
    <cam-link camTestId="cam-link">A link</cam-link>
    <cam-badge camTestId="cam-badge" value="badge" />
    <cam-bullet camTestId="cam-bullet" />
    <cam-new camTestId="cam-new" [visible]="true" [isRelative]="true" />
    <cam-typed-message camTestId="cam-typed-message" text="hello" type="info" />
    <cam-banner camTestId="cam-banner" message="banner message" />
    <cam-toast camTestId="cam-toast">toast content</cam-toast>
  `
})
export class UiTextCase {}
